import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { GlobalHttpInterceptorService } from './GlobalHttpInterceptorService';
import { CredentialsInterceptor } from './noop-interceptor';

export const interceptorProviders =
   [
    { provide: HTTP_INTERCEPTORS, useClass: GlobalHttpInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: CredentialsInterceptor, multi: true }
];